import { render, staticRenderFns } from "./TaxReturnInvoicesTableModal.vue?vue&type=template&id=73ea010c&scoped=true"
import script from "./TaxReturnInvoicesTableModal.vue?vue&type=script&lang=js"
export * from "./TaxReturnInvoicesTableModal.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnInvoicesTableModal.vue?vue&type=style&index=0&id=73ea010c&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ea010c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ea010c')) {
      api.createRecord('73ea010c', component.options)
    } else {
      api.reload('73ea010c', component.options)
    }
    module.hot.accept("./TaxReturnInvoicesTableModal.vue?vue&type=template&id=73ea010c&scoped=true", function () {
      api.rerender('73ea010c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnInvoicesTableModal.vue"
export default component.exports